import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import reducers from './redux/index';
import * as serviceWorker from './serviceWorker';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { CookiesProvider } from 'react-cookie';
import './assets/scss/layout.scss';

import immutableCheckMiddleWare from 'redux-immutable-state-invariant';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const dependencies = {
  history: createBrowserHistory()
};

const store = createStore(
  reducers(dependencies.history),
  composeEnhancers(
    applyMiddleware(
      routerMiddleware(dependencies.history),
      thunk.withExtraArgument({ history: dependencies.history }),
      logger,
      immutableCheckMiddleWare()
    )
  )
);

ReactDOM.render(
  <Provider store={store}>
    <CookiesProvider>
      <App dependencies />
    </CookiesProvider>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
